export default __webpack_public_path__ + "static/media/close-filter.c728d616.svg";